import { Component, lazy, Suspense } from 'react';

import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

import type { Props, State } from './types';

const NotFoundPage = lazy(() => import('@/pages/not-found'));

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(): State {
    return {
      hasError: true,
    };
  }

  public override componentDidCatch() {
    sendGlobalErrorProps({
      errorType: 'generalError',
    });
  }

  override render() {
    // The fallback is lazy and the boundary sits above the router's Suspense, so it brings its own.
    return this.state.hasError ? (
      <Suspense fallback={null}>
        <NotFoundPage />
      </Suspense>
    ) : (
      this.props.children
    );
  }
}
